import React from 'react';
import { Dialog, DialogTitle } from "@mui/material";

import { useTranslations } from "@fenetech/translations";
import useIsMobile from "helpers/hooks/useIsMobile";
import { ILineItem, IQuote } from "helpers/interfaces";
import LineItemPrice from "./LineItemPrice";


interface IProps {
    dialogVisible: boolean;
    quote: IQuote;
    lineItem: ILineItem | null;
    onCancel: () => void;
    onSubmit: (lineItem: ILineItem, newPrice: number) => void;
}

const LineItemPriceDialog: React.FC<IProps> = ({ dialogVisible, quote, lineItem, onCancel, onSubmit }: IProps) => {

    const tm = useTranslations();
    const isMobile = useIsMobile();

    if (!lineItem) {
        return <></>;
    }

    return <>
        <Dialog
            open={dialogVisible}
            onClose={onCancel}
            fullWidth={isMobile}
            maxWidth={isMobile ? "xs" : undefined}
        >
            <DialogTitle>{tm.Get("Price")}</DialogTitle>
            <LineItemPrice
                quote={quote}
                lineItem={lineItem}
                onSubmit={onSubmit}
                onCancel={onCancel}
            />
        </Dialog>
    </>;

}

export default LineItemPriceDialog;